import { theme } from "@theme";
import { ensureStackAnchorListeners } from "@utils/navigation/ensureStackAnchor";
import { Stack } from "expo-router";

export const unstable_settings = {
  initialRouteName: "index",
};

export default function HomeStack() {
  return (
    <Stack
      screenOptions={{
        headerShown: false,
        contentStyle: {
          backgroundColor: theme.colors.screenBg,
        },
      }}
      screenListeners={ensureStackAnchorListeners("index")}
    >
      <Stack.Screen name="index" options={{ animation: "none" }} />
      <Stack.Screen name="access" options={{ animation: "none" }} />
      <Stack.Screen name="genre/[genreId]" />
      <Stack.Screen name="setlists" />
    </Stack>
  );
}
